export default __webpack_public_path__ + "static/media/roadmap_img2.aae726a0.svg";